import { useEffect, useRef } from 'react';
import { ClockAPI } from '../utils/api/clockApi';
import { clockTicketsSignature, collectClockTickets } from '../utils/clockTickets';

const DEBOUNCE_MS = 800;

/**
 * Keep the server clock's due-ticket list in sync for this campaign.
 * Signature ignores the ticking countdown so we do not PUT every second.
 */
export function useClockTicketSync({
  tasks = [],
  lockStates = {},
  campaignId,
  campaignName = '',
  breadcrumbPath = [],
  enabled = true,
}) {
  const lastSigRef = useRef('');
  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled || !campaignId) return undefined;

    const tickets = collectClockTickets({
      tasks,
      lockStates,
      campaignId,
      campaignName,
      breadcrumbPath,
    });
    const signature = `${campaignId}:${clockTicketsSignature(tickets)}`;
    if (signature === lastSigRef.current) return undefined;

    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      lastSigRef.current = signature;
      ClockAPI.putTickets(campaignId, tickets);
    }, DEBOUNCE_MS);

    return () => clearTimeout(timerRef.current);
  }, [tasks, lockStates, campaignId, campaignName, breadcrumbPath, enabled]);
}
